<template>
    <div class="tableStyle">
      <div class="tableBox">
        <div class="tableStyle-right">
          <div class="carStateTable">
            <el-scrollbar>
                 <el-tabs v-model="activeName" @tab-click="handleClick">
                      <el-tab-pane :label="$t('GovernmentRegulation.carAnnualReview')" name="first">
                          <carAnnualReview ref='TabCar'></carAnnualReview>
                      </el-tab-pane>
                      <el-tab-pane :label="$t('GovernmentRegulation.driverAnnualReview')" name="second">
                          <driverAnnualReview ref='TabDriver'></driverAnnualReview>
                      </el-tab-pane>
                  </el-tabs> 
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import AnnualReview from "./AnnualReview.js";
  export default AnnualReview;
  </script>
  
  <style lang="less" scoped>
  @import "../../../assets/styles/Style.less";
  </style>
  
  